"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMaxHeight = void 0;
const react_1 = require("react");
const useWindowSize_1 = require("./useWindowSize");
function useMaxHeight() {
    const { width } = (0, useWindowSize_1.useWindowSize)({ width: true });
    const ref = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        if (ref.current) {
            const height = window.visualViewport.height || window.innerHeight;
            ref.current.style.height = `${height}px`;
        }
    }, [width]);
    return ref;
}
exports.useMaxHeight = useMaxHeight;
